// TinyMCE 4.4.1 places the caret on mousedown with document.caretPositionFromPoint whenever it
// exists, and reads `.offsetNode` without a null check. Chromium 128+ ships that API, and it returns
// null for a click on the iframe's <html> outside <body>. Hiding it on the editor's own iframe
// document sends TinyMCE to caretRangeFromPoint, which Chromium has always had. Firefox has no
// caretRangeFromPoint, so its documents keep caretPositionFromPoint.

interface TinyMCE4Editor {
  getDoc: () => Document | null | undefined;
  on: (event: string, callback: () => void) => void;
}

interface TinyMCEEditorManager {
  majorVersion?: string;
  on?: (event: string, callback: (event: { editor: TinyMCE4Editor }) => void) => void;
}

const guarded = new WeakSet();

const preferCaretRangeFromPoint = (doc: Document | null | undefined) => {
  if (!doc || doc === document || !('caretRangeFromPoint' in doc)) return;

  Object.defineProperty(doc, 'caretPositionFromPoint', { value: undefined, configurable: true });
};

export const guardTinyMCE4CaretFromPoint = (tinymce: TinyMCEEditorManager | undefined): void => {
  if (tinymce?.majorVersion !== '4' || typeof tinymce.on !== 'function') return;
  if (guarded.has(tinymce)) return;

  guarded.add(tinymce);
  tinymce.on('AddEditor', ({ editor }) => {
    editor.on('PreInit', () => preferCaretRangeFromPoint(editor.getDoc()));
  });
};
